import * as React from "react";
import { ResponsiveContainer, LineChart, YAxis, XAxis, Line } from "recharts";

export interface DailyData {
  date: string;
  [key: string]: number | string | null | undefined;
}

interface DailyCasesChartTinyProps {
  data: DailyData[];
  dataKey: string;
  color: string;
  height?: number;
  width?: number | string;
}

const DailyCasesChartTiny: React.FC<DailyCasesChartTinyProps> = ({
  data,
  dataKey,
  color,
  height = 35,
  width = "100%",
}) => {
  const firstDataIndex = data.findIndex((d: any) => d[dataKey]);
  const dataToPlot = data.slice(firstDataIndex, data.length);

  return (
    <div css={{ height, width }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={dataToPlot}
          margin={{ top: 2, bottom: 2, left: 2, right: 2 }}
        >
          <YAxis domain={["dataMin", "dataMax"]} hide={true} />
          <XAxis dataKey="date" hide={true} />

          <Line
            type="basis"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={3}
            connectNulls={true}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DailyCasesChartTiny;
